import React, { useEffect, createElement } from 'react';
import { Toaster } from 'sonner';
import { PIXEL_ID, CHECKOUT_URL } from './utils/constants';
import { StickyBar } from './components/StickyBar';
import { HeroSection } from './components/HeroSection';
import { SocialProof } from './components/SocialProof';
import { ProblemSection } from './components/ProblemSection';
import { EmotionalTransition } from './components/EmotionalTransition';
import { ProductPresentation } from './components/ProductPresentation';
import { WhatIsIncluded } from './components/WhatIsIncluded';
import { PackComposite } from './components/PackComposite';
import { BonusSection } from './components/BonusSection';
import { UrgencySection } from './components/UrgencySection';
import { OfferSection } from './components/OfferSection';
import { TestimonialsSection } from './components/TestimonialsSection';
import { GuaranteeSection } from './components/GuaranteeSection';
import { TrustBar } from './components/TrustBar';
import { FAQSection } from './components/FAQSection';
import { Footer } from './components/Footer';
import { PurchasePopup } from './components/PurchasePopup';
import { CountdownTimer } from './components/CountdownTimer';
export function App() {
  useEffect(() => {
    try {
      const w = window as any;
      if (w.fbq) return;
      const n = w.fbq = function (...args: any[]) {
        if (n.callMethod) {
          n.callMethod.apply(n, args);
        } else {
          n.queue.push(args);
        }
      } as any;
      if (!w._fbq) w._fbq = n;
      n.push = n;
      n.loaded = true;
      n.version = '2.0';
      n.queue = [] as any[];
      const script = document.createElement('script');
      script.async = true;
      script.src = 'https://connect.facebook.net/en_US/fbevents.js';
      const firstScript = document.getElementsByTagName('script')[0];
      if (firstScript && firstScript.parentNode) {
        firstScript.parentNode.insertBefore(script, firstScript);
      } else {
        document.head.appendChild(script);
      }
      w.fbq('init', PIXEL_ID);
      w.fbq('track', 'PageView');
    } catch (error) {
      console.error('Meta Pixel initialization failed:', error);
    }
  }, []);
  return <div className="min-h-screen font-sans" data-id="element-0">
      <Toaster data-id="element-1" />
      <PurchasePopup data-id="element-2" />

      <StickyBar data-id="element-3" />

      <main data-id="element-4">
        <HeroSection data-id="element-5" />
        <SocialProof data-id="element-6" />
        <ProblemSection data-id="element-7" />
        <EmotionalTransition data-id="element-8" />
        <ProductPresentation data-id="element-9" />
        <WhatIsIncluded data-id="element-10" />
        <PackComposite data-id="element-11" />
        <BonusSection data-id="element-12" />
        <UrgencySection data-id="element-13" />
        <OfferSection data-id="element-14" />
        <TestimonialsSection data-id="element-15" />
        <GuaranteeSection data-id="element-16" />
        <TrustBar data-id="element-17" />
        <FAQSection data-id="element-18" />

        {/* Final CTA Section */}
        <section className="py-20 bg-zinc-950 px-4 text-center" data-id="element-19">
          <div className="max-w-3xl mx-auto" data-id="element-20">
            <h2 className="text-3xl md:text-5xl font-bold text-white mb-6 leading-tight" data-id="element-21">
              💃 Diventa l'insegnante di tango che i tuoi studenti ricorderanno
              davvero
            </h2>
            <p className="text-xl text-stone-300 mb-10" data-id="element-22">
              Accedi ora al Metodo Completo per Insegnanti di Tango e trasforma
              il tuo modo di insegnare.
            </p>

            <div className="flex justify-center mb-8" data-id="element-23">
              <CountdownTimer variant="light" data-id="element-24" />
            </div>

            <a href={CHECKOUT_URL} target="_blank" rel="noopener noreferrer" className="inline-block bg-green-500 hover:bg-green-600 text-white rounded-full py-5 px-12 font-bold text-xl md:text-2xl shadow-[0_0_20px_rgba(34,197,94,0.4)] transition-all animate-pulse-fast" data-id="element-25">
              🟢 ACQUISTA ORA
            </a>
          </div>
        </section>
      </main>

      <Footer data-id="element-26" />
    </div>;
}